import React from 'react'
import { GroupContainer, SelectLabel, SelectOption, OptionInput } from './SelectInputElements'

const SelectInput = ({ removeSpacing, label, name, handleChange, value, reference, options, ...otherProps }) => {
    return (
        <GroupContainer className={removeSpacing ? 'reduceSpace' : 'normal'}>
            <SelectLabel>{label}</SelectLabel>
            <SelectOption
                name={name}
                onChange={handleChange}
                value={value}
                ref={reference}
                {...otherProps}
            >
                {
                    options.map(option => (
                        <OptionInput key={option} value={option}>{option}</OptionInput>
                    ))
                }
            </SelectOption>
        </GroupContainer>
    )
}

export default SelectInput
